import { useContext } from "react";
import { FormContextMA } from "../form-context";
import { DataField, H2, Section, TealSubSection } from "./common-components";
import { trimesterEnum } from "../../patient/clinical-services/service-steps/pre-assessment/data";
import {
  calculateAge,
  calculateAgeYear,
  formatDateToDD_MMM_YYYY,
} from "../../../helpers/functions";
import { GetAlertConfirmation } from "../../../helpers/constant";

export const Adherence = ({ formType, clinicalAssessment }) => {
  // const { clinicalAssessment } = useContext(FormContextMA);

  const riskFactors = [];
  if (
    clinicalAssessment?.routine !== "No" &&
    clinicalAssessment?.routineType === "Usually"
  )
    riskFactors.push("Forgets to take medication");
  if (clinicalAssessment?.compliance)
    riskFactors.push("Stop taking medication");
  if (clinicalAssessment?.refill === "Late")
    riskFactors.push("Late medication refills");

  const adherenceObj = {
    result: riskFactors.length > 0,
    riskFactor: riskFactors.join(", "),
  };

  return (
    <Section className="space-y-[0.0833333in]" formType={formType}>
      <H2>Medication Adherence</H2>
      <div className="grid grid-cols-2">
        <div className="flex flex-col gap-[0.0833333in]">
          <DataField
            label="Assessment Results"
            value={adherenceObj.result ? "Risk for adherence" : "No risk for adherence"}
            vertical={false}
            noWrapValue={true}
          />
        </div>
        {adherenceObj.result && (
          <div className="flex flex-col gap-[0.0833333in]">
            <DataField label="Risk factors" value={adherenceObj.riskFactor} />
          </div>
        )}
      </div>
    </Section>
  );
};
